import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/accounts/:email',
      name: 'profile',
      component: () => import('@/views/AccountProfile.vue'),
      meta: {
        pageTitle: 'Profile',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Account Profile',
            active: true,
          },
        ],
      },
    },
    {
      path: '/accounts/:email/devices/:device',
      name: 'account-device',
      component: () => import('@/views/Device.vue'),
      meta: {
        pageTitle: 'Device Details',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Device',
            active: true,
          },
        ],
      },
    },
    {
      path: '/accounts/:email/purchases/:id',
      name: 'purchase',
      component: () => import('@/views/Purchase.vue'),
      meta: {
        pageTitle: 'Purchase Details',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Purchase',
            active: true,
          },
        ],
      },
    },
    {
      path: '/',
      name: 'accounts',
      component: () => import('@/views/Accounts.vue'),
      meta: {
        pageTitle: 'Accounts',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Accounts',
            active: true,
          },
        ],
      },
    },
    {
      path: '/devices',
      name: 'devices',
      component: () => import('@/views/Devices.vue'),
      meta: {
        pageTitle: 'Devices',
        authRequired: true,
        breadcrumb: [
          {
            text: 'List',
            active: true,
          },
        ],
      },
    },
    {
      path: '/books',
      name: 'books',
      component: () => import('@/views/Books.vue'),
      meta: {
        pageTitle: 'Books',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Books',
            active: true,
          },
        ],
      },
    },
    {
      path: '/cpbooks',
      name: 'cpbooks',
      component: () => import('@/views/CPBooks.vue'),
      meta: {
        pageTitle: 'Chess PPub Books',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Chess Pub Books',
            active: true,
          },
        ],
      },
    },
    {
      path: '/books/add',
      name: 'add-books',
      component: () => import('@/views/AddBook.vue'),
      meta: {
        pageTitle: 'Books',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Create',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reviews',
      name: 'reviews',
      component: () => import('@/views/Reviews.vue'),
      meta: {
        pageTitle: 'Reviews',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Reviews',
            active: true,
          },
        ],
      },
    },
    {
      path: '/cpbooks/add',
      name: 'add-cpbooks',
      component: () => import('@/views/AddCPBook.vue'),
      meta: {
        pageTitle: 'ChessPuB Books',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Create',
            active: true,
          },
        ],
      },
    },
    {
      path: '/books/:book',
      name: 'Edit Book',
      component: () => import('@/views/Book.vue'),
      meta: {
        pageTitle: 'Books',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Update Book',
            active: true,
          },
        ],
      },
    },
    {
      path: '/cpbooks/:book',
      name: 'Edit Chess Pub Book',
      component: () => import('@/views/CPBook.vue'),
      meta: {
        pageTitle: 'Edit Chess Pub Book',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Update Chess Pub Book',
            active: true,
          },
        ],
      },
    },
    {
      path: '/puzzles/:fen',
      name: 'Update Puzzle',
      component: () => import('@/views/EditPuzzle.vue'),
      meta: {
        pageTitle: 'Puzzles',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Update Puzzle',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sr/:id',
      name: 'Update Sequence',
      component: () => import('@/views/EditSequence.vue'),
      meta: {
        pageTitle: 'Active Learning',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Update Sequence',
            active: true,
          },
        ],
      },
    },
    {
      path: '/purchases',
      name: 'purchases',
      component: () => import('@/views/Purchases.vue'),
      meta: {
        pageTitle: 'Purchases',
        authRequired: true,
        breadcrumb: [
          {
            text: 'List',
            active: true,
          },
        ],
      },
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: () => import('@/views/Notifications.vue'),
      meta: {
        pageTitle: 'Notifications',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Notification',
            active: true,
          },
        ],
      },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/Settings.vue'),
      meta: {
        pageTitle: 'Settings',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Global',
            active: true,
          },
        ],
      },
    },
    {
      path: '/puzzles',
      name: 'puzzles',
      component: () => import('@/views/Puzzles.vue'),
      meta: {
        pageTitle: 'Puzzles',
        authRequired: true,
        breadcrumb: [
          {
            text: 'List',
            active: true,
          },
        ],
      },
    },
    {
      path: '/support',
      name: 'support',
      component: () => import('@/views/Support.vue'),
      meta: {
        pageTitle: 'Support',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Support queue',
            active: true,
          },
        ],
      },
    },
    {
      path: '/support/:id',
      name: 'support-item',
      component: () => import('@/views/SupportItem.vue'),
      meta: {
        pageTitle: 'Support',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Support',
            to: '/support',
          },
          {
            text: 'Message',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {
    // get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser

    // If auth required, check login. If login fails redirect to login page
    if (to.meta.authRequired && firebaseCurrentUser === null) {
      router.push({ path: '/login', query: { to: to.path } })
    }

    return next()
  })
})

export default router
